import { usePrequalificationGetQuery } from 'api/customPortalApi';

export const usePrequalificationData = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const applicationId = queryParams.get('applicationId') as string;

  const { data: preQualification, isLoading, isFetching } = usePrequalificationGetQuery({ query: { applicationId } });

  return {
    preQualification: preQualification?.data,
    isFetching,
    isLoading,
    applicationId,
  };
};
